module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "reviews"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_A"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "revi_p1"
    }
  }, [_c('b', [_vm._v("Praise for "), _c('i', [_vm._v("The Rare Coin Score")]), _vm._v(" and Richard Stark:")])]), _vm._v(" "), _c('p', {
    staticClass: "extra-indent2",
    attrs: {
      "id": "revi_p2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "revi_p3"
    }
  }, [_vm._v("“The caper novel, the story of a major criminal operation from the point of view of the participants, has no better practitioner than Richard Stark. "), _c('i', [_vm._v("The Rare Coin Score")]), _vm._v(" . . . is an unusually good caper even for Stark's hard-bitten professional thief, Parker. The million-dollar heist of an important numismatic convention is clean and sharp in its prose, plotting and characterization, and it is nicely twisted in its surprises.”")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "revi_p4"
    }
  }, [_vm._v("—Anthony Boucher, "), _c('i', [_vm._v("New York Times Book Review")])]), _vm._v(" "), _c('p', {
    staticClass: "extra-indent2",
    attrs: {
      "id": "revi_p5"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "revi_p6"
    }
  }, [_vm._v("“Richard Stark's Parker . . . is refreshingly amoral, a thief who always gets away with the swag.”")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "revi_p7"
    }
  }, [_vm._v("—Stephen King, "), _c('i', [_vm._v("Entertainment Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "extra-indent2",
    attrs: {
      "id": "revi_p8"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "revi_p9"
    }
  }, [_vm._v("“Richard Stark's Parker novels, a cluster of which were written in an extraordinary burst of creativity in the early '60s, are among the most poised and polished fictions of their time and, in fact, of any time.”")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "revi_p10"
    }
  }, [_vm._v("—John Banville, "), _c('i', [_vm._v("Bookforum")])]), _vm._v(" "), _c('p', {
    staticClass: "extra-indent2",
    attrs: {
      "id": "revi_p11"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "revi_p12"
    }
  }, [_vm._v("“Gritty and chillingly noir . . . [Westlake] succeeds in demonstrating his total mastery of crime fiction.”")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "revi_p13"
    }
  }, [_c('i', [_vm._v("—Booklist")])]), _vm._v(" "), _c('p', {
    staticClass: "extra-indent2",
    attrs: {
      "id": "revi_p14"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "revi_p15"
    }
  }, [_vm._v("“The Parker novels . . . are among the greatest hard-boiled writing of all time.”")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "revi_p16"
    }
  }, [_c('i', [_vm._v("—Financial Times")]), _vm._v(" (London)")]), _vm._v(" "), _c('p', {
    staticClass: "extra-indent2",
    attrs: {
      "id": "revi_p17"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_B"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "revi_p18"
    }
  }, [_vm._v("“If you're looking for crime novels with a lot of punch, try the very, very tough novels featuring Parker by Donald E. Westlake (writing as Richard Stark). [They] are all beautifully paced [and] tautly composed.”")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "revi_p19"
    }
  }, [_vm._v("—James Kaufmann, "), _c('i', [_vm._v("Christian Science Monitor")])]), _vm._v(" "), _c('p', {
    staticClass: "extra-indent2",
    attrs: {
      "id": "revi_p20"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "revi_p21"
    }
  }, [_vm._v("“Westlake is among the smoothest, most engaging writers on the planet.”")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "revi_p22"
    }
  }, [_vm._v("—"), _c('i', [_vm._v("San Diego Tribune")])]), _vm._v(" "), _c('p', {
    staticClass: "extra-indent2",
    attrs: {
      "id": "revi_p23"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "revi_p24"
    }
  }, [_vm._v("“Elmore Leonard wouldn't write what he does if Stark hadn't been there before. And Quentin Tarantino wouldn't write what he does without Leonard. . . . Old master that he is, Stark does them all one better.”")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "revi_p25"
    }
  }, [_c('i', [_vm._v("—L.A. Times")])]), _vm._v(" "), _c('p', {
    staticClass: "extra-indent2",
    attrs: {
      "id": "revi_p26"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "revi_p27"
    }
  }, [_vm._v("“Westlake's ability to construct an action story filled with unforeseen twists and quadruple-crosses is unparalleled.”")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "revi_p28"
    }
  }, [_c('i', [_vm._v("—San Francisco Chronicle")])]), _vm._v(" "), _c('p', {
    staticClass: "extra-indent2",
    attrs: {
      "id": "revi_p29"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "revi_p30"
    }
  }, [_vm._v("“What chiefly distinguishes Westlake, under whatever name, is his passion for process and mechanics. . . . Parker appears to have eliminated everything from his program but machine logic, but this is merely protective coloration. He is a romantic vestige, a free-market anarchist whose independent status is becoming a thing of the past.”")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "revi_p31"
    }
  }, [_vm._v("—Luc Sante, "), _c('i', [_vm._v("New York Review of Books")])]), _vm._v(" "), _c('p', {
    staticClass: "extra-indent2",
    attrs: {
      "id": "revi_p32"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "body-text",
    attrs: {
      "id": "revi_p33"
    }
  }, [_vm._v("“No one can turn a phrase like Westlake.”")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "revi_p34"
    }
  }, [_c('i', [_vm._v("—Detroit News and Free Press")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e165635","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reviews.vue
// module id = 57
// module chunks = 0